import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { func, array } from 'prop-types';
import { translate } from 'react-i18next';

import { Button } from '@snapask/common-components';

import LineSelect from '@dragonfruit/components/fields/LineSelect';
import { clearSchools } from '@dragonfruit/redux/schools';

import styles from './ChangeSchoolForm.scss';

const cx = require('classnames/bind').bind(styles);

class ChangeSchoolForm extends Component {
  static propTypes = {
    clearSchools: func.isRequired,
    districtList: array.isRequired,
    schoolList: array.isRequired,
    t: func.isRequired,
    onSelectDistrict: func.isRequired,
    onSubmit: func.isRequired,
  };

  state = {
    showSchoolField: false,
    school: {
      value: 0, // school id.
      label: '', // school name.
    },
    selectedDistrictId: 0,
  };

  handleDistrictChange = district => {
    const { onSelectDistrict, clearSchools } = this.props;

    this.setState({
      showSchoolField: true,
      selectedDistrictId: district.value,
    });

    clearSchools();
    onSelectDistrict(district);
  };

  handleSchoolChange = school => {
    this.setState({
      school: {
        label: school.label,
        value: school.value,
      },
    });
  };

  handleSubmit = () => {
    const { school } = this.state;
    this.props.onSubmit({ school });
  };

  render() {
    const { t, districtList, schoolList } = this.props;

    const { showSchoolField, selectedDistrictId, school } = this.state;
    const schoolId = school.value;

    const districtOptions = districtList.map(d => ({
      value: d.id,
      label: d.name,
    }));

    const schoolOptions = schoolList.map(d => ({
      value: d.id,
      label: d.name,
    }));

    // add custom school which is typed in by users.
    schoolOptions.push(school);

    return (
      <div>
        <div className={styles.field}>
          <LineSelect
            floatingLabelText={t('fieldLabel:fieldLabel.district')}
            options={districtOptions}
            clearable={false}
            onChange={this.handleDistrictChange}
            value={selectedDistrictId}
            searchable
            openOnFocus
            openOnClick
          />
        </div>

        <div
          className={cx('field', {
            hide: !showSchoolField,
          })}
        >
          <LineSelect
            floatingLabelText={t('fieldLabel:fieldLabel.school')}
            options={schoolOptions}
            clearable={false}
            promptTextCreator={label => `${t('account.addNewSchool')} ${label}`}
            onChange={this.handleSchoolChange}
            value={schoolId}
            openOnClick={false}
            openOnFocus={false}
            arrowRenderer={() => {}}
            creatable
            searchable
          />
        </div>
        <Button
          text={t('account.confirmChangeSchool')}
          primary
          onClick={this.handleSubmit}
        />
      </div>
    );
  }
}

export default compose(
  translate(['account', 'error', 'fieldLabel']),
  connect(null, {
    clearSchools,
  })
)(ChangeSchoolForm);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/AccountProfileVerify/components/ChangeSchoolForm/ChangeSchoolForm.jsx